export const vendorRouteConfig = {
  "/vendor/dashboard": {
    pageTitle: "Dashboard",
    breadcrumbs: [
      { label: "Home", url: "/vendor/dashboard" }
    ]
  },

  "/vendor/vprofile": {
    pageTitle: "Profile",
    breadcrumbs: [
      { label: "Home", url: "/vendor/dashboard" },
      { label: "Profile", url: "/vendor/vprofile" }
    ]
  },

  "/vendor/my-services": {
    pageTitle: "My Services",
    breadcrumbs: [
      { label: "Home", url: "/vendor/dashboard" },
      { label: "My Services", url: "/vendor/my-services" }
    ]
  },

  "/vendor/vendorstudent": {
    pageTitle: "Vendor Students",
    breadcrumbs: [
      { label: "Home", url: "/vendor/dashboard" },
      { label: "Vendor Students", url: "/vendor/vendorstudent" }
    ]
  },

  "/vendor/bookings": {
    pageTitle: "Service Bookings",
    breadcrumbs: [
      { label: "Home", url: "/vendor/dashboard" },
      { label: "Service Bookings", url: "/vendor/bookings" }
    ]
  }
};
